import { useState } from "react"
import { api } from "@/shared/api-client"

const MESSAGES: Record<string, string> = {
  delivery_unavailable: "Регистрация сейчас недоступна: владельцу не удаётся передать данные. Попробуйте позже.",
  delivery_failed: "Не удалось передать данные владельцу. Ничего не создано — попробуйте позже.",
  invalid_display_name: "Имя: до 40 символов, буквы, цифры, пробел, точка или дефис.",
  register_home_only: "Регистрация доступна только из домашней сети.",
  too_many_requests: "Слишком много попыток. Подождите немного и повторите.",
}

const input =
  "w-full px-3.5 py-2.5 rounded-lg bg-white/[5%] border border-white/[8%] text-zinc-200 placeholder:text-zinc-600 focus:outline-none focus:border-violet-500/60 text-sm"
const label = "block text-xs font-medium text-zinc-400 mb-1.5 uppercase tracking-wide"
const btn =
  "w-full py-2.5 px-4 rounded-lg bg-gradient-to-r from-[var(--hh-accent-from)] to-[var(--hh-accent-to)] hover:brightness-110 text-white text-sm font-medium disabled:opacity-60"

/** Создание аккаунта: только имя. Временные логин и пароль Джарвис отправляет ВЛАДЕЛЬЦУ; на экране их нет. */
export function RegisterForm({ onBack }: { onBack: () => void }) {
  const [name, setName] = useState("")
  const [sent, setSent] = useState(false)
  const [error, setError] = useState("")
  const [busy, setBusy] = useState(false)
  const [again, setAgain] = useState(false)
  const [asked, setAsked] = useState(false)

  async function askAgain(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    setBusy(true)
    try {
      await api.post("/register/reissue-request", { display_name: name.trim() })
      setAsked(true)
    } catch (err) {
      const m = err instanceof Error ? err.message : ""
      setError(MESSAGES[m] ?? (m || "Не получилось. Попробуйте ещё раз."))
    } finally {
      setBusy(false)
    }
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    setBusy(true)
    try {
      await api.post("/register/start", { display_name: name.trim() })
      setSent(true)
    } catch (err) {
      const m = err instanceof Error ? err.message : ""
      setError(MESSAGES[m] ?? (m || "Не получилось. Попробуйте ещё раз."))
    } finally {
      setBusy(false)
    }
  }

  if (again) {
    return (
      <form onSubmit={askAgain} className="space-y-4">
        {asked ? (
          <p className="text-sm text-emerald-400">
            Запрос отправлен. Если ваши прежние данные истекли или заблокированы, владелец получил уведомление и сможет
            выдать новые. На экране они не показываются.
          </p>
        ) : (
          <>
            <div>
              <label className={label}>Имя, указанное при регистрации</label>
              <input className={input} value={name} onChange={(e) => setName(e.target.value)} required autoFocus maxLength={40} />
            </div>
            {error && <p className="text-sm text-rose-400">{error}</p>}
            <button className={btn} disabled={busy}>{busy ? "Отправляю…" : "Запросить новые временные данные"}</button>
          </>
        )}
        <button type="button" className="text-xs text-zinc-500 hover:text-zinc-300" onClick={() => { setAgain(false); setAsked(false) }}>← Назад</button>
      </form>
    )
  }

  if (sent) {
    return (
      <div className="space-y-4">
        <p className="text-sm text-emerald-400">Заявка создана.</p>
        <p className="text-xs text-zinc-400">
          Временные логин и пароль отправлены владельцу — он передаст их вам. Введите их на вкладке «Войти» в течение 30 минут и
          выберите свои логин и пароль. Доступ откроется после того, как владелец подтвердит вас и ваше устройство.
        </p>
        <button className={btn} onClick={onBack}>К входу</button>
      </div>
    )
  }
  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <label className={label}>Как вас зовут</label>
        <input className={input} value={name} onChange={(e) => setName(e.target.value)} placeholder="например, Джастин" required autoFocus maxLength={40} />
      </div>
      <p className="text-xs text-zinc-500">Это закрытая семейная система: владелец сам выдаст вам временные данные для входа.</p>
      {error && <p className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/20 rounded-lg px-3 py-2">{error}</p>}
      <button className={btn} disabled={busy}>{busy ? "Отправляю…" : "Создать аккаунт"}</button>
      <button type="button" className="text-xs text-zinc-400 hover:text-zinc-200" onClick={() => setAgain(true)}>
        Запросить новые временные данные
      </button>
    </form>
  )
}
